import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { MdMoreHoriz } from 'react-icons/md';
//import PersonModal from '../../../../Modals/PersonModal/PersonModal';
import ConfirmPopOver from '../../../common/ConfirmPopOver';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';


function EmailsListItem(props) {
    const { t } = useTranslation();
    const { email, deleteEmail, eventID } = props;
    const history = useHistory();
    const navigateToEmail = () => history.push(`/events/${eventID}/emails/${email.partnerEmailId}`);

    const onDelete = () => deleteEmail(email);

    const DeleteItem = () => (
		<ConfirmPopOver
			placement="left"
			title={t('emails.delete_email')}
			onConfirm={onDelete}
			confirmText={t('general.delete')}
			cancelText={t('general.cancel')}
			triggerElement={
				<span className="dropdown-item" style={{ cursor: 'pointer' }}>
					{t('general.delete')}
				</span>
			}
		/>
    );
    
    const statusClass = classNames({
		'badge-danger': (email && email.status === 'failed'),
		'badge-warning': (email && email.status === 'sending'),
		'badge-secondary': (email && email.status === 'draft'),
		'badge-light-primary': (email && email.status === 'sent'),
	});

    return (
        <React.Fragment>
            <div className="DataListItem row align-items-center" key={email.partnerEmailId} style={{paddingTop: '20px', paddingBottom: '20px'}}>
                <div className="col-lg-5">
                    <span style={{ cursor: 'pointer' }} onClick={navigateToEmail}>
                        <span><strong>{email.title}</strong></span>
                    </span>
                </div>
                {/*<div className="col-lg-3">
                    <span><strong> {moment(email.timeSent).format('DD.MM.YYYY - HH:mm')}</strong></span>
                </div>*/}
                <div className="col-lg-4">
                    {t('emails.recipient_count') + email.partnerEmailRecipients.length}
                </div>
                <div className="col-lg-2">
                    <div className={`badge status-badge ${statusClass}`} style={{ minWidth: 80 }}>
						{t('email_status.' + email.status)}
					</div>
                </div>
                <div className="col text-right">
                    <Dropdown>
                        <Dropdown.Toggle as="span">
                            <MdMoreHoriz style={{fontSize: '18px'}} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight>
                            <Dropdown.Item onClick={navigateToEmail}>
                                {t('general.edit')}
                            </Dropdown.Item>
                            <Dropdown.Item as={DeleteItem} />
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </React.Fragment>

    )
}

export default EmailsListItem;